import { render, staticRenderFns } from "./WorkerSkillsInventory.vue?vue&type=template&id=4981f9fc&"
import script from "./WorkerSkillsInventory.vue?vue&type=script&lang=js&"
export * from "./WorkerSkillsInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkillsInventoryCharts: require('/workspace/components/SkillsInventory/Charts/SkillsInventoryCharts.vue').default})
